import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { SHOWS } from "../../data/content";
import RevealSection from "./RevealSection";
import HiddenMonkey from "./HiddenMonkey";

const ROTATE = [-2, 1.6];
const COLLAGE = ["collage tone-white", "collage collage-3 tone-cream"];

export default function Espectacles() {
  return (
    <RevealSection id="espectacles" className="px-5 py-24">
      <div className="mx-auto max-w-6xl">
        <header className="mb-14 text-center">
          <span className="font-hand text-2xl font-bold text-terracotta">del nostre quadern de creació</span>
          <h2 className="mt-1 font-display text-4xl font-bold text-forest sm:text-5xl">Els nostres espectacles</h2>
          <p className="mx-auto mt-3 max-w-xl font-body text-forest/70">
            Teatre de petit format, fet a mà i pensat per créixer amb els infants.
          </p>
        </header>

        <div className="grid gap-12 md:grid-cols-2">
          {SHOWS.map((show, i) => (
            <motion.article
              key={show.id}
              initial={{ rotate: ROTATE[i % 2] }}
              whileHover={{ y: -8, rotate: 0 }}
              transition={{ type: "spring", stiffness: 220, damping: 16 }}
              className={`relative p-5 pb-7 ${COLLAGE[i % 2]}`}
              data-testid={`show-card-${show.id}`}
            >
              <HiddenMonkey spotId={show.id} />
              <div className="relative aspect-square overflow-hidden bg-kraft">
                <img src={show.image} alt={show.title} className="h-full w-full object-cover" />
                <span className="absolute left-3 top-3 rounded-full bg-forest/90 px-3 py-1 font-body text-xs font-bold text-paper">
                  {show.age}
                </span>
              </div>

              <div className="px-3 pt-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-display text-3xl font-bold lowercase text-forest">{show.title}</h3>
                  <span className="font-hand text-xl font-bold text-sage-ink">{show.tag}</span>
                </div>
                <p className="mt-3 font-body leading-relaxed text-forest/80">{show.description}</p>
                <ul className="mt-5 flex flex-wrap gap-2">
                  {show.bullets.map((b) => (
                    <li key={b} className="rounded-full bg-sage/12 px-3 py-1 font-body text-xs font-semibold text-forest">
                      {b}
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/espectacles/${show.id}`}
                  className="relative z-30 mt-5 inline-flex items-center gap-1 font-display text-sm font-semibold text-forest link-draw"
                  data-testid={`show-link-${show.id}`}
                >
                  Veure la fitxa →
                </Link>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </RevealSection>
  );
}
